import { render, staticRenderFns } from "./UsersGoalsTable.vue?vue&type=template&id=7ad3e788&scoped=true&"
import script from "./UsersGoalsTable.vue?vue&type=script&lang=js&"
export * from "./UsersGoalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad3e788",
  null
  
)

export default component.exports